define('app/views/show_more_deals',['app/setup', 'app/models/deal_card', 'app/collections/deal_collection'],
function(takhfifan, dealCard, dealCollection) {

  takhfifan.showMoreDeals = Backbone.View.extend({
    events: {
      'click .tkh-load-more-deal__trigger': 'loadMore'
    },

    template: ( $('#deal-list-template').length > 0 ) ?
      _.template( $('#deal-list-template').html() ) : '',


    initialize: function () {
      this.collection = new takhfifan.DealCardCollection;
      this.collection.entityId = this.$el.data('entityId');
      this.collection.type = this.$el.data('type');
      this.collection.offset = this.$el.parent('.deals').find('.deal').length;
      this.collection.nextPage = 1;
      this.$el.find('.tkh-load-more-deal__trigger').css('visibility', 'visible');
      var _this = this;
      
      var automaticLoad = _.debounce(function() {
        if(_this.activateAutoLoad &&  _this.isOnViewport()){
           _this.loadMore();
         }
      }, 300);

      this.activateAutoLoad = false;

      $(window).scroll(automaticLoad);

    },

    isOnViewport: function (){
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = this.$el.offset().top;
      var elemBottom = elemTop + this.$el.height();
   
      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    },
    
    loadMore: function () {
      var _this = this;
      if(this.collection.nextPage === -1){
        this.activateAutoLoad = false;
        return;
      }
      this.$el.addClass('loading-view');
      this.collection.fetch({
        success: function (collection, response, options) {
          try {
            _this.$el.before(_this.template({
                deals: collection.toJSON()
            }));
          }
          catch (e) {
              console.warn("error: template");
          }
          _this.$el.removeClass('loading-view');
          if(_this.collection.nextPage !== 1){
            _this.$el.find('.tkh-load-more-deal__trigger').hide();
            _this.activateAutoLoad = true;
            try {
                _this.automaticLoad();
            }
            catch (e) {
                console.warn("error: automaticLoad");
            }
          }
        },
        error: function(){
          _this.$el.removeClass('loading-view');
        }
      });
    }
  })
});
